import React, { ReactElement } from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import { EditIcon } from '../../../../resources/svgComponents/EditIcon';
import { RemoveIcon } from '../../../../resources/svgComponents/RemoveIcon';
import { UserItemToDisplayType } from './utils';
import CoinIcon from '../../../../resources/svgComponents/CoinIcon';
import { ControllerIcon } from '../../../../resources/svgComponents/ControllerIcon';
import { ClockIcon } from '../../../../resources/svgComponents/ClockIcon';
import Eye from 'react-native-vector-icons/FontAwesome';
import { useGetHivesQuery } from '../../MyHives/useGetHivesQuery.gql';

const InfoCard = ({ icon, title, value }: { icon: ReactElement; title: string; value: string }) => {
  return (
    <View style={styles.infoCard}>
      <Text style={styles.infoKey}>{title}</Text>
      <View style={styles.infoCardFooter}>
        {icon}
        <Text style={styles.infoValue} numberOfLines={1}>
          {value}
        </Text>
      </View>
    </View>
  );
};

const UserItemSmall = ({
  user,
  editAction,
  removeAction,
  rangeQuery,
  navigation,
  hiveId,
}: UserItemToDisplayType) => {
  return (
    <View style={[styles.itemCard]}>
      <View style={styles.header}>
        <Text style={styles.userNameText}>{`${user.firstName} ${user.lastName}`}</Text>
        <View style={{ flexDirection: 'row' }}>
          <TouchableOpacity
            onPress={() => {
              navigation.navigate('HiveJourneys', {
                journey: true,
                userId: user.id,
                userName: user.userName,
                hiveId,
              });
            }}
            style={{ marginHorizontal: 10 }}
          >
            <Eye name={'eye'} size={20} color="#000000" />
          </TouchableOpacity>
          <TouchableOpacity onPress={editAction} style={{ marginHorizontal: 10 }}>
            <EditIcon />
          </TouchableOpacity>
          <TouchableOpacity onPress={removeAction} style={{ marginHorizontal: 10 }}>
            <RemoveIcon />
          </TouchableOpacity>
        </View>
      </View>
      <View style={{ paddingVertical: 12, paddingHorizontal: 8 }}>
        <View style={{ flexDirection: 'row', marginBottom: 12 }}>
          <Text style={styles.userInfoLabel}>Username</Text>
          <Text style={styles.userInfoText}>{user.userName}</Text>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <Text style={styles.userInfoLabel}>Password</Text>
          <Text style={styles.userInfoText}>{user.password}</Text>
        </View>
      </View>
      <View style={styles.analyticsContainer}>
        <View style={styles.hline} />
        <InfoCard
          icon={<ControllerIcon size={18} />}
          title="Total Games"
          value={`${user.numberOfGames}`}
        />
        <View style={styles.hline} />
        <InfoCard
          icon={<ClockIcon size={20} />}
          title="Total Time (min) "
          value={Math.round((user.totalTime ?? 0) / 60000).toString()}
        />
        {!rangeQuery && (
          <InfoCard icon={<CoinIcon size={18} />} title="Points" value={`${user.points}`} />
        )}
      </View>
    </View>
  );
};

export { UserItemSmall };

const styles = StyleSheet.create({
  userInfoText: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: '600',
    alignSelf: 'center',
    color: '#453B3B',
  },
  itemCard: {
    borderWidth: 1,
    borderColor: '#E5E5E5',
    backgroundColor: '#F9F9F9',
    padding: 16,
    marginBottom: 12,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderColor: '#E5E5E5',
    paddingHorizontal: 8,
    paddingBottom: 12,
  },
  userNameText: {
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: '600',
    alignSelf: 'center',
    flex: 1,
    color: '#453B3B',
  },
  userInfoLabel: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: '400',
    alignSelf: 'center',
    color: '#453B3B',
    marginRight: 12,
  },
  analyticsContainer: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#E5E5E5',
    backgroundColor: '#FFF',
    borderRadius: 8,
  },
  infoCard: {
    flex: 1,
    paddingTop: 13,
    paddingLeft: 6,
    paddingBottom: 12,
  },
  infoKey: {
    fontFamily: 'Inter',
    color: '#453B3B',
    fontSize: 12,
    textAlign: 'left',
  },
  infoValue: {
    fontFamily: 'Inter',
    color: '#453B3B',
    fontSize: 14,
    marginLeft: 5,
    fontWeight: '600',
  },
  infoCardFooter: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 16,
  },
  hline: {
    width: 1,
    backgroundColor: '#E5E5E5',
    height: '100%',
  },
});
